import { render, staticRenderFns } from "./SEOSectionRenameMetaDesction.vue?vue&type=template&id=5ab80f0e"
import script from "./SEOSectionRenameMetaDesction.vue?vue&type=script&lang=js"
export * from "./SEOSectionRenameMetaDesction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports